// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2nyTh","title":"InfoRow_title__1FH8A"};